import { tenderAIAPi } from './tender-ai-api';
const getProposalDocs = (proposalId) => {
    return tenderAIAPi.get(`document/${proposalId}/GetByProposalId`);
};
const getDocById = (documentId) => {
    return tenderAIAPi.get(`document/GetDocumentPdfByDocumentId/${documentId}`, {
        responseType: 'blob'
    });
};
const getDocByPath = (documentPath) => {
    return tenderAIAPi.get(`document/GetPdfDocument/${documentPath}`, {
        responseType: 'blob'
    });
};
const downloadProposalDocs = (file) => {
    return tenderAIAPi.get(`document/${file.folderName}/${file.fileName}`);
};
const ProposalDocsApi = {
    getProposalDocs,
    downloadProposalDocs,
    getDocById,
    getDocByPath
};
export default ProposalDocsApi;
